module.exports = (angularModule) => {

  angularModule
    .controller("AccountManagerCtrl", AccountManagerCtrl);

  AccountManagerCtrl.$inject = ['$state', '$location', 'accountsService', 'pagingService', 'userService', 'configService','adminSearchService','updateService','stringService','$uibModal'];
  function AccountManagerCtrl($state, $location, accountsService, pagingService, userService, configService, adminSearchService, updateService, stringService,$uibModal) {
    console.log('load accounts')
    var vm = this;
    vm.readyForActivation = false;
    vm.accountSearchQuery = adminSearchService.getSearchQuery();
    vm.freshQuery = null;
    vm.totalAccounts = null;
    vm.loadingAccounts = true;

    vm.updateConfig = {
      entityId : null,
      pageOneResult : true
    }

    vm.pageStrings = stringService.adminStrings();
    vm.state = "DoneUpdating";

    vm.refreshAccounts = function () {
      vm.loadingAccounts = true;
      vm.accountSearchQuery = adminSearchService.getSearchQuery();
      vm.freshQuery = vm.accountSearchQuery;
      accountsService.listAccounts({query:vm.accountSearchQuery}).then(function (accountResp) {
        configService.getBrandConfig(false).then(function (brandResp){
          userService.currentUser().then(function(userResp){
            var accounts = accountResp.accounts;
            vm.brandRestrictions = brandResp.restrictions;
            vm.userInfo = userResp;
            vm.totalAccounts = accounts.length;
            vm.accountsPaged = pagingService.createPagingData(accounts, 15);

            if(pagingService.getCurrentPage()){
              vm.accountsPaged.currentPageNum = pagingService.getCurrentPage();
            }
            vm.loadingAccounts = false;
            if(vm.updateConfig.entityId){
              if(_.where(vm.accountsPaged.pagedItems[0],{id:vm.updateConfig.entityId}).length>0){
                vm.updateConfig.pageOneResult = true;
              }
            }
          })
        })
      });
    };

    vm.updatePagingState = function(){
      pagingService.setCurrentPage(vm.accountsPaged.currentPageNum);
    }

    vm.openConfirmDeleteAccountModal = function (account) {
      $uibModal.open({
        controller: 'ConfirmDeleteAccountCtrl',
        template: require('./confirmDeleteAccount.html'),
        resolve: {
          account: () => account
        }
      }).result.then(() => vm.deleteAccount(account));
    };

    vm.openBrandSettingsModal = function(account){
      var modalInstance = $uibModal.open({
        template: require('../brand/brandSettingsModalTemplate.html'),
        size: 'lg',
        resolve:  {
          config : () => {
            return configService.getBrandConfigForAccount(account.id).then(function (resp) {
              return resp.data.config
            }, (error) => {
            })
          }
        },
        controller: ["$scope","config",function($scope,config) {

          let states = {
            init : "Init",
            editing : "Editing",
            loading : "Loading",
            updating : "Updating",
            success : "Success",
            error: "Error"
          }
          $scope.states = states
          $scope.account = account
          $scope.config = config
          $scope.restrictionConfig = {
            restrictionsToUpdate : {}
          }
          $scope.popoverConfig = {
            title : "Confirm Delete",
            message : "Warning: This will remove this tag from all reviews!",
            doNotShow : false
          }


          let maybeRefreshBrandConfig = () => {
            if(vm.userInfo.accountId == account.id){
              configService.getBrandConfig(false,true)
            }
          }

          $scope.state = states.editing
          $scope.popoverOpen = {}
          $scope.selectedTab = "tabs"
          $scope.brandModalConfig = {
            state : {
              updating: false,
              success: false
            },
            save : false,
            reviewTagTerm : ""
          }
          $scope.reviewTags = config.reviewTags
          $scope.brandModalConfig.save = false;
          $scope.setSelectedTab = (name) => {
            $scope.selectedTab = name;
            $scope.state = states.init
          }

          $scope.save = function(){
            $scope.state = states.updating;
            if($scope.selectedTab == 'tabs' || $scope.selectedTab == 'features'){
              configService.updateBrandRestrictions(account.id,$scope.restrictionConfig.restrictionsToUpdate).then(function(resp){
                maybeRefreshBrandConfig()
                $scope.state = states.success;
              },(error) => {
                $scope.state = states.error;
              })
            }
            else if($scope.selectedTab == 'reviewTags'){
              configService.saveReviewTags(account.id,$scope.reviewTags).then((resp) => {
                maybeRefreshBrandConfig()
                configService.getBrandConfigForAccount(account.id).then(function (configResp) {
                  $scope.config = configResp.data.config
                  $scope.reviewTags = $scope.config.reviewTags
                  $scope.state = states.success;
                })

              },(error) => {
                $scope.state = states.error;
              })
            }
          }

          $scope.account = account;
        }]
      });

      modalInstance.closed.then(res => {
        /*vm.brandModalConfig.state.updating = false;
        vm.brandModalConfig.state.success = false;*/
      });
    }

    vm.updateAccount = function () {
      vm.updateErrorMsg = '';
      vm.loadingAccounts = true;
      accountsService.updateAccount(vm.accountEditor.account).then(function () {
        $state.reload();
      }, function updateError() {
        vm.updateErrorMsg = 'An error occurred while updating account: ' + vm.accountEditor.originalAccount.accountName +
        ' to ' + vm.accountEditor.account.accountName + '!';
        vm.refreshAccounts();
      });
    };

    vm.deleteAccount = function (account) {
      vm.state = "PendingConfirmation";
      var resetAcct;
      if (vm.accountId == accountsService.getCurrentAccount()){
        resetAcct = true;
      }
      accountsService.deleteAccount(account).then(function () {
        if(resetAcct){
          accountsService.setCurrentAccount("all");
        }
        var updateInfo = {
          status: "Active",
          type: "account",
          title: "Account",
          destinationRole: "manage",
          notificationType: "detail",
          actions: [{action:"delete"}],
          entity: account,
          id: account.id,
          name: account.accountName,
          searchParam: account.accountName
        }
        updateService.registerSuccessfulUpdate(updateInfo);
        $state.reload();
      },function(){
        vm.state = "doneUpdating"
      });
    };

    vm.goToAccountEditor = function(opType, account){
      if(opType == "create"){
        $location.path('/admin/v2/accounts/create');
      }
      else{
        $location.path('/admin/v2/accounts/'+account.id+'/edit');
      }
    }

    vm.showEditAccountPopup = function (account) {
      vm.accountEditor = {};
      vm.accountEditor.originalAccount = angular.copy(account);
      vm.accountEditor.account = angular.copy(account);

      $('#editAccountModal').modal();
    };

    vm.isUpdatedItemRow = function(id,entityId){
      return id==entityId;
    }

    activate();

    function activate() {
      vm.refreshAccounts();
    }
  }
}
